import apiDefaults from '@/api/defaultConfiguration';
import { DamagecasesApiFactory } from '@/api/generated';
import { getUnixTimestamp } from '@/plugins/Utils';

export default {
	state: {
		repairProof: null,
	},
	getters: {
		getRepairProof(state) {
			return state.repairProof;
		},
	},
	mutations: {
		clearRepairProof(state) {
			state.repairProof = null;
		},
		setRepairProof(state, payload) {
			state.repairProof = payload;
			state.repairProof._ttl = getUnixTimestamp() + 60;
		},
	},
	actions: {
		updateRepairProof({ commit, dispatch, getters }, payload) {
			const id = payload?.id || getters.getDamageCase?.id;
			const isDamageCaseSet = getters.getDamageCase?.id !== undefined;
			const isDifferentId = isDamageCaseSet && payload.id && payload?.id.toString() !== getters.getDamageCase?.id.toString();
			const isRepairProofSet = getters.getRepairProof?.id;
			const isRepairProofOutdated = isRepairProofSet && getters.getRepairProof?._ttl < getUnixTimestamp();

			if (id && (!isRepairProofSet || isDifferentId || isRepairProofOutdated)) {
				return DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.damagecasesIdRepairproofGet(id)
					.then(response => {
						if (response.data) {
							commit('setRepairProof', response.data);
						}
					})
					.catch(() => commit('setRepairProof', {}));
			}
		},
	},
};
